const operation = {
  // 交易行规则
  chargeRule: `/jyhApi/sellerCentral/chargeRule`,
  // 用户搜索记录
  userSearchLog: `/jyhApi/sellerCentral/userSearchLog`,
  // 添加搜索记录
  addUserSearchLog: `/jyhApi/sellerCentral/addUserSearchLog`,
  // 游戏列表
  gameList: `/jyhApi/sellerCentral/gameList`,
  // 指定我数量及买家还价红点
  unReadRed: `/jyhApi/sellerCentral/unReadRed`,
  // 删除搜索记录
  delSearchLog: `/jyhApi/sellerCentral/delSearchLog`,
  // 卖家个人页面
  sellerPersonalPage: `/jyhApi/sellerCentral/sellerPersonalPage`,
  // 卖家游戏列表
  sellerGame: `/jyhApi/sellerCentral/sellerGame`,
  // 充值协议
  rechargeAgreement: `/jyhApi/sellerCentral/rechargeAgreement`
};

export default operation;
